import { Component, ChangeDetectionStrategy, OnInit, OnDestroy, inject } from '@angular/core';
import { BreadcrumbItem, SeoComponent } from '@shared/components';
import { RoutingTabTitleService } from '@shared/service/routing-tab-title/routing-tab-title.service';
import { WindowService } from '@shared/window/window.service';
import { tap } from 'rxjs/operators';
import { VideoComponent } from '../../shared/components/video/video.component';
import { TitleComponent } from '../../shared/components/title/title.component';
import { History1Component } from '../components/history-1/history-1.component';
import { History2Component } from '../components/history-2/history-2.component';
import { OurProductsComponent } from '../components/our-products/our-products.component';

@Component({
    selector: 'app-about-us',
    templateUrl: './about-us.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [VideoComponent, TitleComponent, History1Component, History2Component, OurProductsComponent],
})
export class AboutUsComponent extends SeoComponent implements OnInit, OnDestroy {
    private windowService = inject(WindowService);
    private routingTabTitleService = inject(RoutingTabTitleService);

    breadcrumbs: BreadcrumbItem[] = [
        {
            name: 'NAVIGATION.MAIN.main_page',
            url: '/',
        },
        {
            name: 'NAVIGATION.MAIN.about_us',
            url: '/about-us',
        },
    ];

    override ngOnInit(): void {
        super.ngOnInit();

        this.windowService.scrollTop();

        this.subscriptions$.add(
            this.routingTabTitleService.currentPageTitle$
                .pipe(
                    tap((title) => {
                        this.seoTitle$.next(title);
                        this.seoDescription$.next(this.routingTabTitleService.translateTitle('SEO.ABOUT_US.description'));
                    }),
                )
                .subscribe(),
        );
    }
}
